
export type MarkNotificationAsDelivered200Status = {
  isRead: boolean;
};
